import { ReactElement, ReactNode } from "react";

const PageTitleContainer = ({ children }: { children: ReactElement }) => {
  return <div className="w-full border-b border-solid p-4">{children}</div>;
};

const PageTitle = ({ children }: { children: ReactNode }) => {
  return <h1 className="text-2xl">{children}</h1>;
};

export { PageTitle, PageTitleContainer };
